export const STRIPE_URL = "https://buy.stripe.com/fZu14od2l3SFeGsdBL1ck0r";
export const PRICE_OLD = "1697 zł";
export const PRICE_NEW = "219 zł";
export const PRODUCT_NAME = "Pakiet Bezpieczna Restauracja";
export const HERO_BG =
  "https://images.unsplash.com/photo-1613274554329-70f997f5789f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHx3YXJtJTIwcmVzdGF1cmFudCUyMGludGVyaW9yJTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3ODg2Mjc0MDd8MA&ixlib=rb-4.1.0&q=85";
export const SECURED_COUNT = 132;
export const AUTHOR_NAME = "Paulina Dawidowicz";
export const AUTHOR_TITLE = "prawnik · doktorantka";
export const AUTHOR_EMAIL = "prawodorzeczy@gmail.com";
export const AUTHOR_SITE = "https://prawodorzeczy.pl";
export const AUTHOR_INSTAGRAM = "https://www.instagram.com/prawo.do.rzeczy";
export const AUTHOR_FACEBOOK = "https://www.facebook.com/people/prawodorzeczy/61576799432830";
export const DOWNLOAD_URL = "/pliki/pakiet-bezpieczna-restauracja.zip";

export const getCookie = (name) =>
  document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${name}=`))
    ?.split("=")
    .slice(1)
    .join("=") || null;
